import React, { Component } from 'react';
import './index.scss';
import { DEVICE_DETACTION } from '../../utils/device';

class TagList extends Component {
    constructor (props) {
        super(props);
        this.listRef = React.createRef();
    }

    /**
     * WAI-ARIA Tabs keyboard navigation
     * - ArrowLeft / ArrowRight: move focus between tabs (wraps around)
     * - Home: move focus to the first tab
     * - End: move focus to the last tab
     */
    onKeyDown = (e) => {
        const list = this.listRef.current;
        if (!list) return;

        const tabs = Array.from(list.querySelectorAll('[role="tab"]'));
        if (tabs.length === 0) return;

        const currentIndex = tabs.indexOf(document.activeElement);
        if (currentIndex === -1) return;

        let nextIndex;

        switch (e.keyCode) {
            case 37: // ArrowLeft
                nextIndex = currentIndex > 0 ? currentIndex - 1 : tabs.length - 1;
                break;
            case 39: // ArrowRight
                nextIndex = currentIndex < tabs.length - 1 ? currentIndex + 1 : 0;
                break;
            case 36: // Home
                nextIndex = 0;
                break;
            case 35: // End
                nextIndex = tabs.length - 1;
                break;
            default:
                return;
        }

        e.preventDefault();
        e.stopPropagation();
        tabs[nextIndex].focus();
        // Automatic activation: selecting the tab on focus so aria-selected updates
        // and screen readers announce the selected state immediately
        tabs[nextIndex].click();
    }

    render () {
        return (
            <ul ref={this.listRef} className={`tag-list ${this.props.className||''}`} style={this.props.style} role="tablist" onKeyDown={this.onKeyDown}>{this.props.children}</ul>
        )
    }
}

class TagListItem extends Component {
    constructor (props) {
        super(props);
    }

    // Enter / Space key handler — activate the tab
    onKeyDown = (e) => {
        if (e.keyCode === 13 || e.keyCode === 32) {
            e.stopPropagation();
            e.preventDefault();
            this.props.onClick();
        }
    }

    render () {
        const { mobile, ios, android, iphone, ipad, touch } = DEVICE_DETACTION;
        // WAI-ARIA: only the active tab is in the tab order (roving tabindex)
        let tabIndex = this.props.active ? 0 : -1;
        if (touch || mobile || ios || android || iphone || ipad) {
            tabIndex = null;
        }
        return (
            <li id={this.props.id} className={`tag-list-item${this.props.active?' active':''}`} tabIndex={tabIndex} onKeyDown={this.onKeyDown} onClick={this.props.onClick} role="tab" aria-selected={!!this.props.active} aria-controls={this.props.ariaControls}>{this.props.children}</li>
        )
    }
}

export { TagList, TagListItem };
